import React from "react";
import { StyledBubbleItem } from "./style";

export const LoadingBubble = () => {
  return (
    <StyledBubbleItem>
      <div className="loading-message bubble">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </StyledBubbleItem>
  );
};
